import { StyledFooter } from "./footer-styles";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <StyledFooter>
      <section id="footer">
        <div className="container">
          <div className="row gy-5 text-center text-xs-center text-sm-left text-md-left">
            <div className="col-xs-12 col-sm-6 col-md-6 d-flex justify-content-center align-items-center">
              <Link to="/">
                <h1 className="">Medistak</h1>
              </Link>
            </div>

            <div className="col-xs-12 col-sm-6 col-md-6">
              <h5>Quick links</h5>
              <ul className="list-unstyled quick-links">
                <li>
                  <Link to="/">
                    <span>Home</span>
                  </Link>
                </li>
                <li>
                  <Link to="/medical-suppliers">
                    <span>Suppliers</span>
                  </Link>
                </li>
                <li>
                  <Link to="/health-facilities">
                    <span>Health facilities</span>
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      <div className="bottomBar">
        <p>&copy; Copyright 2021 all rights reserved</p>
      </div>
    </StyledFooter>
  );
};

export default Footer;
